<template>
  <div class="league">
    <img src="../../assets/images/home/jiameng.png" alt="">
    <div class="container">
      <div class="flow">
        <h3>城市合伙人加盟流程</h3>
        <p class="eng">City Partner Joining Process</p>
        <ul class="list">
          <li>
            <div class="img">
              <img src="../../assets/images/home/dianhua.png" alt="">
              <p>1.电话咨询</p>
            </div>
          </li>
          <li>
            <img class="icon" src="../../assets/images/home/jiantou.png" alt="">
          </li>
          <li>
            <div class="img">
              <img src="../../assets/images/home/kaocha.png" alt="">
              <p>2.双方考察</p>
            </div>
          </li>
          <li>
            <img class="icon" src="../../assets/images/home/jiantou.png" alt="">
          </li>
          <li>
            <div class="img">
              <img src="../../assets/images/home/hezuo.png" alt="">
              <p>3.签订合同</p>
            </div>
          </li>
          <li>
            <img class="icon" src="../../assets/images/home/jiantou.png" alt="">
          </li>
          <li>
            <div class="img">
              <img src="../../assets/images/home/yunying.png" alt="">
              <p>4.运营支撑</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="adv">
        <h3>城市合伙人加盟流程</h3>
        <p class="eng">City Partner Joining Process</p>
        <img src="../../assets/images/home/youshi.png" alt="">
      </div>
      <div class="adv">
        <h3>城市合伙人加盟流程</h3>
        <p class="eng">City Partner Joining Process</p>
        <img src="../../assets/images/home/yaoqiu.png" alt="">
      </div>
      <el-form :model="info" ref="info" :rules="rules" label-width="112px" class="demo-ruleForm">
        <h3>城市合伙人加盟流程</h3>
        <p class="eng">City Partner Joining Process</p>
        <el-form-item
                label="加盟城市："
                prop="city"
        >
          <area-city @city="leagueCity" ref="city" />
        </el-form-item>
        <el-form-item
                label="加盟者姓名："
                prop="name"
        >
          <el-input type="text" v-model="info.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
                label="加盟者电话："
                prop="phone"
        >
          <el-input type="text" v-model="info.phone" autocomplete="off" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item
                label="加盟者邮箱："
                prop="email"
        >
          <el-input type="text" v-model="info.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('info')">点击提交</el-button>
          <p>提交成功后我们会尽快联系您！</p>
        </el-form-item>

      </el-form>
    </div>
  </div>
</template>

<script>
import AreaCity from '../../components/AreaCity'
import {reqLeague} from '../../api/index'
export default {
  data () {
    let validEmail = (rule,value,callback) => {
      let reg=/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
      if(!reg.test(value)){
        callback(new Error('邮箱格式不正确'))
      }else{
        callback()
      }
    }
    let validPhone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/
      if(!reg.test(value)){
        callback(new Error('手机号码不正确'))
      }else{
        callback()
      }
    }
    return {
      info: {
        city: [],
        name: '',
        phone: '',
        email: ''
      },
      rules: {
        city:[{ required: true, message: '请选择地址', trigger: 'blur' }],
        name:[{ required: true, message: '请输入加盟者姓名', trigger: 'blur' }],
        phone:[{ required: true, message: '请输入加盟者电话', trigger: 'blur' },{validator: validPhone, trigger: 'blur'}],
        email:[{ required: true, message: '请输入加盟者邮箱', trigger: 'blur' },{validator: validEmail, trigger: 'blur'}],
      }
    }
  },
  methods: {
    leagueCity(data) {
      this.info.city = data
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          reqLeague(this.info).then(res => {
            if(res.code === 200){
              if(res.data.bussData){
                this.$message({message:'添加成功', type: 'success'})
                this.info.name = ''
                this.info.phone = ''
                this.info.email = ''
              }
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  components: {
    AreaCity
  }
}
</script>

<style scoped lang="less" type="text/less">
  .league{
    margin-bottom: 39px;
    .flow{
      padding-top:77px;
      .list{
        display: flex;
        justify-content: space-around;
        margin-top:58px;
        li{
          display: flex;
          .img{
            p{
              margin-top:22px;
              text-align: center;
              color:#000;
              font-size: 18px;
              font-weight: bold;
            }
          }

        }
        .icon{
          width: 43px;
          height: 17px;
          margin:55px 0 55px 0;
        }
      }
    }
    .adv{
      margin-top:94px;
      img{
        margin-top:45px;
      }
    }
    .demo-ruleForm{
      margin-top:94px;
      text-align: center;
      .eng{
        margin-bottom: 39px;
      }
      p{
        text-align: center;
      }
    }
    h3{
      font-size:24px;
      font-family:Alibaba-PuHuiTi-H;
      font-weight:800;
      text-align: center;
      color:#000;
    }
    .eng{
      margin-top:18px;
      font-size:18px;
      font-family:Alibaba-PuHuiTi-R;
      text-align: center;
      color:#999;
    }
    .el-form-item{
      width: 466px;
      margin: 0 auto 20px;
    }
    /*提交按钮*/
    .el-button--primary{
      width: 200px;
      height: 48px;
      border-radius: 24px;
      background: #61aee6;
      border-color:#61aee6;
      font-size: 18px;
      font-weight: bold;
      box-shadow:0px 5px 9px 0px rgba(0, 0, 0, 0.15);
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Home/League.vue